import React, {FC, useEffect, useState} from "react";
import axios from "axios";
import {setInterval} from "timers";

interface TableProps{
  className?:string;
}
const Table: FC<TableProps> = () => {
  const [coins, setCoins] = useState<any>([]);

  const fetchData = async () => {
    const url = "https://api.coingecko.com/api/v3/coins/markets?vs_currency=gbp&order=market_cap_desc&per_page=6&page=1&sparkline=false";

    const response = await axios.get(url);
    if (response.status >= 300) return;

    setCoins(
      response.data.map((coin: any) => {
        return {
          count: coin.current_price,
          thumbnail: coin.image,
          href: `coin/${coin.id}`,
          ...coin
        }
      })
    )
  }

  useEffect(()=> {
    fetchData();
    const interval = setInterval(() => fetchData(), 30000);

    return () => {
      clearInterval(interval);
    }
  }, [])

  return(
    <div className="overflow-hidden relative bg-neutral-100 dark:bg-black dark:bg-opacity-20 relative overflow-x-auto shadow-md sm:rounded-lg w-full text-sm text-left text-gray-500 dark:text-gray-400 container flex flex-col py-2 inline-block min-w-full sm:px-6 lg:px-8 overflow-hidden  min-w-full">
      <table className="overflow-hidden relative w-full text-sm text-left text-gray-500 dark:text-gray-400">
        <thead className="border-b dark:border-gray-700 overflow-hidden relative text-xs text-gray-700 uppercase  dark:text-gray-400">
          <tr>
            <th className="px-6 py-3 font-bold text-gray-900 dark:text-white whitespace-nowrap" scope="col">Name</th>
            <th className="px-6 py-3 font-bold text-gray-900 dark:text-white whitespace-nowrap " scope="col">Price</th>
            <th className="px-6 py-3 font-bold text-gray-900 dark:text-white whitespace-nowrap " scope="col">24Hr %</th>
            {/*<th className="px-6 py-3 font-bold text-gray-900 dark:text-white whitespace-nowrap " scope="col">Market Cap</th>*/}
          </tr>
        </thead>
        <tbody>
        {
          coins?.map((coin: any) => {
            return (
              <tr className="overflow-hidden relative border-b dark:border-gray-700 hover:bg-primary-6000 dark:hover:bg-primary-6000" key={coin.id}>
                <td>
                  <a href={coin.href}>
                    <div className="uppercase px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                      {coin.symbol}
                    </div>
                  </a>
                </td>
                <td>
                  <a href={coin.href}>
                    <div className="uppercase px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                      £ {coin.current_price}
                    </div>
                  </a>
                </td>
                <td>
                  <a href={coin.href}>
                    <div className="uppercase px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                      { coin.price_change_percentage_24h >= 0
                        ? <span className="text-green-400">+{coin.price_change_percentage_24h}%</span>
                        : <span className="text-red-500">{coin.price_change_percentage_24h}%</span>
                      }
                    </div>
                  </a>
                </td>
              {/*  <td>
                  <a href={coin.href}>
                    <div className="uppercase px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                      £ {coin.market_cap}
                    </div>
                  </a>
                </td>*/}
              </tr>
            )
          })
        }
        </tbody>
      </table>
    </div>
  );

}
export default Table;
